import { useIntl } from "react-intl";

interface ReservationNextStepsProps {
  type: "flight" | "hotel";
}

export const ReservationNextSteps = ({ type }: ReservationNextStepsProps) => {
  const intl = useIntl();
  const showFlightInfo = type === "flight";
  const showHotelInfo = type === "hotel";

  return (
    <section className="mt-4">
      <h3 className="section-title">
        {intl.formatMessage({
          defaultMessage: "What's next?",
          description: "reservations.whatsNext",
        })}
      </h3>
      <div className="section-card flex flex-col gap-2 text-sm">
        {showFlightInfo ? (
          <p>
            {intl.formatMessage({
              defaultMessage:
                "If you would like to pre-select your seat, please enter your ticket number and last name on the airline's website to reserve your seat two hours before takeoff.",
              description: "reservations.flight.whatsNextDescription",
            })}
          </p>
        ) : null}
        {showHotelInfo ? (
          <p>
            {intl.formatMessage({
              defaultMessage:
                "Provide hotel personnel with reservation number while checking in.",
              description: "reservations.hotel.whatsNextDescription",
            })}
          </p>
        ) : null}
      </div>
    </section>
  );
};
